<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0" v-if="display === 1">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  お問い合わせ</li>
                </ul>
              </nav>

							<div class="card w-100">
                <div class="card-header">お問い合わせ<br><span class="small text-warning">※5日経っても返事がない場合は、お手数ですがこちら [ customer@piachu.net ] まで連絡をお願いいたします。</span></div>

								<div class="card-body">

                  <div class="form-group">
										<label for="type" class="d-block col-form-label">お問い合わせの種類:</label>
                    <select v-bind:class="{ error_input: contactForm.errors.type.length > 0 }" v-model="contactForm.type">
                      <option value="">選択してください</option>
                      <option v-for="(item, index) in types" :value="index+1" :key="`type-${item.no}`">{{ item.name }}</option>
                    </select>
                    <div v-if="contactForm.errors.type.length > 0">
                      <div class="error-text" v-for="(item, index) in contactForm.errors.type" :key="index">{{ item }}</div>
                    </div>
                  </div>

                  <div class="form-group">
										<label for="name" class="d-block col-form-label">お名前:</label>
                    <input type="text" placeholder="ピアノ 太郎" v-model="contactForm.name" class="" v-bind:class="{ error_input: contactForm.errors.name.length > 0 }">
                    <div v-if="contactForm.errors.name.length > 0">
                      <div class="error-text" v-for="(item, index) in contactForm.errors.name" :key="index">{{ item }}</div>
                    </div>
                  </div>

                  <div class="form-group">
										<label for="email" class="d-block col-form-label">メールアドレス:</label>
                    <input type="text" placeholder="example@piachu.net" v-model="contactForm.email" class="" v-bind:class="{ error_input: contactForm.errors.email.length > 0 }">
                    <div v-if="contactForm.errors.email.length > 0">
                      <div class="error-text" v-for="(item, index) in contactForm.errors.email" :key="index">{{ item }}</div>
                    </div>
                  </div>

                  <div class="form-group">
										<label for="contents" class="d-block col-form-label">お問い合わせ内容:</label>
                    <textarea placeholder="" v-model="contactForm.contents" class="w-100" rows="10" v-bind:class="{ error_input: contactForm.errors.contents.length > 0 }"></textarea>
                    <div v-if="contactForm.errors.contents.length > 0">
                      <div class="error-text" v-for="(item, index) in contactForm.errors.contents" :key="index">{{ item }}</div>
                    </div>
                  </div>
                  
									<div class="form-group row mx-0 mb-0">
										<div class="col-md-12 text-center">
											<button type="submit" class="btn btn-success" @click="send_contact">
												お問い合わせ送信
											</button>
										</div>
									</div>

								</div>
							</div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>

	<b-container class="px-3 p-md-0" v-if="display === 2">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  お問い合わせ</li>
                </ul>
              </nav>

							<div class="card w-100">
								<div class="card-header">お問い合わせ</div>

								<div class="card-body p-2">

									<div class="container my-3">
										<div class="form-group w-100 m-auto p-1">
                      お問い合わせありがとうございました。
										</div>
									</div>

								</div>
							</div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'Contact',
  data() {
		const types = [
      {"no":"1","name":"サイトについて"},
      {"no":"2","name":"～～について"},
    ]
    return {
      types,
      display: 1,
      user: null,
			isError: true,
			contactForm: {
				errors: {
					email: [],
					name: [],
					type: [],
					contents: [],
				},
				email: "",
				name: "",
				type: "",
				contents: "",
        users_id: null,
			}

    }
  },
  methods: {
    /*
    * user show
    */
    async current_user() {
      this.$store.dispatch('user/current_user')
      .then(res => {
        this.user = res.data.users;
        console.log(this.user);
        this.contactForm.email = this.user.email;
        this.contactForm.name = this.user.nickname;
        this.contactForm.users_id = this.user.id;
        // this.display = 2;
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error);
        // if ('error' in error.response.data) {
        //   alert(error.response.data['error']);
        //   window.scrollTo({
        //     top: 0,
        //   });
        // }
      });
    },
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
    send_contact() {
			this.isError = false;
			this.contactForm.errors.email = [];
			this.contactForm.errors.name = [];
			this.contactForm.errors.type = [];
			this.contactForm.errors.contents = [];
			if (!this.contactForm.email) {
				this.contactForm.errors.email.push('メールアドレスが入力されていません');
				this.isError = true;
			} else {
				if (this.check_mail(this.contactForm.email)) {
					this.contactForm.errors.email.push('正しいメールアドレス を入力してください');
					this.isError = true;
				}	
			}
			if (!this.contactForm.name) {
				this.contactForm.errors.name.push('お名前が入力されていません');
				this.isError = true;
			}
			if ((!this.contactForm.type) || this.contactForm.type == "") {
				this.contactForm.errors.type.push('種別が選択されていません');
				this.isError = true;
			}
			if (!this.contactForm.contents) {
				this.contactForm.errors.contents.push('お問い合わせ内容が入力されていません');
				this.isError = true;
			}
			if (!this.isError) {
				this.exec_contact();
			} else {
				window.scrollTo({
					top: 0,
				});
			}
			return false;      
    },
		/*
		* exec_contact
		*/
    async exec_contact() {
      this.$store.dispatch('user/exec_contact', {
        contact: this.contactForm
      }).then(res => {
        console.log(res);
        this.display = 2;
        window.scrollTo({
          top: 0,
        });
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          this.isError = true;
          window.scrollTo({
            top: 0,
          });
        }
      });
		},
  },

	computed: {
		...mapState('auth', ['token']),
		token: function() {
			return this.$store.getters["auth/token"];
		}
	},

  created() {
    if ( this.token != null && this.token != '' ) {
      this.current_user();
    }
    // if ( window.innerWidth <= 575 ) { // スマホの場合、非表示
    //   this.display_tab = 0;
    // }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue